"use client";

import { Button } from "../../../elements/button/button";
import type { MainNavigationLink } from "../main-navigation.types";

export interface NavigationServiceLinksProps {
  links: MainNavigationLink[];
  /** The design sets the pills in 24px on desktop and 40px in the mobile menu. */
  size: "xs" | "sm";
  onLinkClick?: () => void;
}

export function NavigationServiceLinks(
  props: Readonly<NavigationServiceLinksProps>
) {
  return (
    <ul className="flex flex-wrap gap-2">
      {props.links.map((link) => (
        <li key={`${link.href}-${link.label}`}>
          <Button
            href={link.href}
            mode="D2C"
            onClick={props.onLinkClick}
            size={props.size}
            target={link.target}
            variant="outline"
          >
            {link.label}
          </Button>
        </li>
      ))}
    </ul>
  );
}
